/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_SendInputs */

const en_us2_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const pt_br2_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const es_419_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const pt_pt2_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const fr_fr2_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_de2_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const it_it2_engagement_send = /** @type {(inputs: Engagement_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Engagement_SendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_send = /** @type {((inputs?: Engagement_SendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_SendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_send(inputs)
	if (locale === "es-419") return es_419_engagement_send(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_send(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_send(inputs)
	if (locale === "de-DE") return de_de2_engagement_send(inputs)
	if (locale === "it-IT") return it_it2_engagement_send(inputs)
	return en_us2_engagement_send(inputs)
});
export { engagement_send as "engagement.send" }